module.exports = __webpack_public_path__ + "static/media/news41.c2c3830d.jpg";